import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import * as api from '../lib/api';

// The author's own in-app notice when Remove from Explore has been imposed.
// Appeal route is the Contact us page, the app's single contact mechanism.
export const ModerationNotice = () => {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .getModerationNotices()
      .then((data) => {
        if (!cancelled) setNotices(data.notices || []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (notices.length === 0) return null;

  return (
    <div className="moderation-notice" data-testid="moderation-notice">
      <ShieldAlert className="moderation-notice-icon" />
      <div className="moderation-notice-body">
        <h3 className="moderation-notice-title">
          {notices.length === 1
            ? 'One of your recommendations was removed from Explore'
            : `${notices.length} of your recommendations were removed from Explore`}
        </h3>
        <p className="moderation-notice-text">
          {notices.length === 1 ? 'It is' : 'They are'} still shared with people you trust, and
          nothing has been deleted. You cannot share {notices.length === 1 ? 'it' : 'them'} with
          everyone again for now.
        </p>
        <ul className="moderation-notice-list">
          {notices.map((n) => (
            <li key={n.recommendationId} data-testid={`moderation-notice-${n.recommendationId}`}>
              {n.name}
            </li>
          ))}
        </ul>
        <Link className="moderation-notice-link" to="/contact" data-testid="moderation-notice-appeal">
          Contact us if you think this is wrong
        </Link>
      </div>
    </div>
  );
};
